import type { ReactNode } from "react";

/**
 * Pushes a panel's content down so it clears the corner number. A panel shed
 * by `collapseOnNarrow` has no body padding of its own, so it needs more.
 */
export function PanelCornerNumberSpace_({
  cornerNumber,
  collapseOnNarrow,
  children,
}: {
  cornerNumber: number | undefined;
  collapseOnNarrow: boolean;
  children: ReactNode;
}) {
  if (cornerNumber === undefined) {
    return children;
  }
  return (
    <div
      className={collapseOnNarrow ? "pt-5 in-[.narrow-cards]:pt-17" : "pt-5"}
    >
      {children}
    </div>
  );
}
